import { chatApiAxios } from "@/plugins";
import { HttpRequestMethodEnum } from "@/types/api";
import { IForwardMessage, IForwardMessageResponse } from "@/types/chat";
import { config } from "@/config";
import { getCommonJsonHeaders } from "@/utils/api";
import { checkAccessTokenAsync } from "@/services/maitrejaApi/auth/checkAccessTokenAsync";

export const forwardMessageBeAsync = async ({
  items,
  messageText,
  messageType,
  accessToken,
}: IForwardMessage) => {
  const res = await chatApiAxios<IForwardMessageResponse>(
    config.api.chatApi.endpoints.message.forwardMessage,
    {
      method: HttpRequestMethodEnum.POST,
      headers: getCommonJsonHeaders(accessToken),
      data: {
        items,
        messageText,
        messageType,
      },
    },
  );

  return res.data.failedIdentifiers;
};
